export default __webpack_public_path__ + "static/media/18-Annual-Picnic-2018.af395207.JPG";